import script from "./PagesList.vue?vue&type=script&setup=true&lang=js"
export * from "./PagesList.vue?vue&type=script&setup=true&lang=js"

import "./PagesList.vue?vue&type=style&index=0&id=d27d54a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d27d54a2"]])

export default __exports__